import { DefinitionNode, DocumentNode, OperationDefinitionNode } from 'graphql';

// TODO: use @apollo/client one
export function operationName(doc: DocumentNode): string {
  const operationDefinition = doc.definitions.find(isOperationDefinitionNode);
  const name = operationDefinition?.name?.value;

  if (name == null) {
    throw new Error('Document does not contain any operation definitions');
  }

  return name;
}

function isOperationDefinitionNode(definition: DefinitionNode): definition is OperationDefinitionNode {
  return definition.kind === 'OperationDefinition';
}
